import { PRICE_HISTORY_SET_MODAL_OPEN } from '../constants';

export const setPriceHistoryModalOpen = (
  modalOpen: boolean,
  previouslyLowestPrice: string,
  numberOfDays: number,
  description: string,
  title: string
) => {
  const action = {
    type: PRICE_HISTORY_SET_MODAL_OPEN,
    payload: {
      modalOpen,
      previouslyLowestPrice,
      numberOfDays,
      description,
      title,
    },
  };
  return action;
};
